var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.73 2.756A6.49 6.49 0 0 0 7.468.072 6.5 6.5 0 0 0 1.004 5.89l-.065.615 1.232.13.064-.617a5.262 5.262 0 0 1 9.698-2.23H9.635v1.237h4.333V.691H12.73v2.065Zm.035 3.755-.064.616a5.262 5.262 0 0 1-9.698 2.23h2.299V8.12H.969v4.333h1.238v-2.065a6.49 6.49 0 0 0 5.261 2.684 6.5 6.5 0 0 0 6.464-5.817l.065-.615-1.232-.13Z",
    fill: "#000"
  })));
};
export default SvgRefresh;